import moment from "moment";
import { array, boolean, InferType, number, object, string } from "yup";
import { TWritingType, TContentType, linksSchema, TOrderType } from "./order";

export const onlineZoomContentSchema = object({
    id: number().required(),
    active: boolean().required("error.order.active.required"),
    contentType: string<TContentType>()
        .required("error.order.contentType.required")
        .default("BLOG"),
    indexChecked: number().nonNullable(),
    indexed: number<0 | 1 | 2 | 3>().required(),
    indexedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    keywords: array()
        .of(string().required())
        .when("opti", {
            is: (opti: boolean) => opti === true,
            then: (schema) =>
                schema.required("error.order.keywords.required").min(1, "error.order.keywords.min"),

            otherwise: (schema) => schema.nullable(),
        }),
    links: array().of(linksSchema.required()).nullable().default(undefined),
    orderType: string<TOrderType>().required(),
    publishedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    url: string().notRequired(),
    wordCount: number().required("error.order.wordCount.required").nonNullable(),
    writingType: string<TWritingType>().required("error.order.writingType.required"),
    nl: number().nullable(),
    silo: number().nullable(),
});

export type OnlineOrder = InferType<typeof onlineZoomContentSchema>;
